import { UserRoles } from '@core/domain';
import type { RootState } from '@store';

/**
 * Select authentication status
 */
export const selectIsAuthenticated = (state: RootState) => state.auth?.isAuthenticated || false;

/**
 * Select the current user
 */
export const selectUser = (state: RootState) => state.auth?.user || null;

/**
 * Select user roles (returns empty array if no user)
 */
export const selectUserRoles = (state: RootState) => state.auth?.user?.roles || [];

/**
 * Select whether the current user has a specific role
 */
const selectHasUserRole = (state: RootState, role: UserRoles) => {
  const userRoles = selectUserRoles(state);

  return userRoles.includes(role);
};

/**
 * Select whether the current user is a system administrator
 * Returns true if the user has the 'Admin' role, false otherwise
 */
export const selectIsUserSystemAdmin = (state: RootState) => selectHasUserRole(state, UserRoles.ADMIN);
